export default "//cdn.scentbird.com/assets/frontbird-site/images/private-library_149c4d.jpg";